import { apiGet } from "./client.js";
import { ApiCallError } from "./client.js";
import type { TemplateRunSummary } from "./product-types.js";

export async function getLatestTemplates(
  websiteId: string,
): Promise<TemplateRunSummary | null> {
  return apiGet<TemplateRunSummary | null>(`/websites/${websiteId}/templates`);
}

export async function getTemplatesById(
  websiteId: string,
  runId: string,
): Promise<TemplateRunSummary | null> {
  try {
    return await apiGet<TemplateRunSummary>(
      `/websites/${websiteId}/templates/${runId}`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}
